import React from 'react';
import { errorClass, FieldTone, inputClass, labelClass } from '../../../utils/fieldStyles';
interface TextFieldProps {
  id: string;
  label: string;
  value: string;
  onChange: (value: string) => void;
  type?: 'text' | 'email' | 'tel';
  required?: boolean;
  autoComplete?: string;
  placeholder?: string;
  error?: string;
  tone?: FieldTone;
}
export function TextField({
  id,
  label,
  value,
  onChange,
  type = 'text',
  required,
  autoComplete,
  placeholder,
  error,
  tone = 'light'
}: TextFieldProps) {
  return <div data-id="element-69" data-mp="1blij8qwx3q84">
      <label htmlFor={id} className={labelClass(tone)} data-id="element-70" data-mp="1bma4b7sw25k5">
        {label}
        {required && <span aria-hidden="true" data-id="element-71" data-mp="xm90bjhbui0g"> *</span>}
      </label>
      <input id={id} name={id} type={type} value={value} required={required} autoComplete={autoComplete} placeholder={placeholder} aria-invalid={Boolean(error)} aria-describedby={error ? `${id}-error` : undefined} onChange={event => onChange(event.target.value)} className={`h-12 ${inputClass(tone, Boolean(error))}`} data-id="element-72" data-mp="12lvepw8w64au" />
      {error && <p id={`${id}-error`} className={errorClass(tone)} data-id="element-73" data-mp="31wrqsqcikvo1">
          {error}
        </p>}
    </div>;
}